<template>
  <div class="login-container">
      <img class="logo" :src="getLogo()" alt="Logo do App">
      <div class="login-content">
          <div class="login-form">
              <div v-if="step === 'password'" class="step-header">
                <span @click="step = 'email'; password = ''" class="back-button">← Voltar</span>
                <p class="user-email-display">{{ email }}</p>
              </div>
              <p class="instruction">{{ instructionText }}</p>
              <div class="form-group" v-if="step === 'email'">
                  <label for="email">E-mail</label>
                  <input type="email" id="email" v-model="email" placeholder="Digite seu e-mail" @keyup.enter="handleEmailStep">
              </div>
              <div class="form-group" v-if="step === 'password'">
                  <label for="password">Senha</label>
                  <input type="password" id="password" v-model="password" placeholder="Digite sua senha" @keyup.enter="handleLogin">
              </div>
              <!--
              <div class="remember-password">
                  <input type="checkbox" id="remember-password" v-model="rememberPassword">
                  <label for="remember-password">Lembrar senha</label>
              </div>
              -->
              <a v-if="step === 'password'" href="#" class="forgot-password" @click="changeRecoverPasswordMenuVisibility">Esqueci minha senha</a>
              <button v-if="step === 'email'" class="button" @click="handleEmailStep">CONTINUAR</button>
              <button v-if="step === 'password'" class="button" @click="handleLogin">ENTRAR</button>
          </div>
    </div>
    <RecoverPasswordComponent></RecoverPasswordComponent>
    <ScreenLoader :isLoading="isLoading" />
  </div>
</template>

<script>
// import { getUserStatusByEmail } from '@/assets/controllers/ApiFlamengoController'
import { doLogin, checkUserByEmail } from '@/assets/controllers/LoginController'
import Util from '@/assets/libs/util'
import RecoverPasswordComponent from '@/components/bottom-popups/RecoverPasswordComponent.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoginView',
  components: {
    RecoverPasswordComponent,
    ScreenLoader
  },
  data () {
    return {
      step: 'email', // 'email' or 'password'
      email: '',
      password: '',
      isLoading: false,
      rememberPassword: true
    }
  },
  computed: {
    ...mapGetters(['getAppDefinitions']),
    instructionText () {
      if (this.step === 'email') {
        return 'Preencha os dados para entrar'
      }
      return 'Agora, digite sua senha'
    }
  },
  methods: {
    ...mapActions(['changeRecoverPasswordMenuVisibility']),
    async handleEmailStep () {
      if (!this.email) {
        Util.showWarningNotification({ title: 'Por favor, informe o seu e-mail.' })
        return
      }
      this.isLoading = true
      const result = await checkUserByEmail(this.email)

      // const responseApiFlamengo = await getUserStatusByEmail(this.email)
      // console.log(responseApiFlamengo)

      if (result.error) {
        this.isLoading = false
        Util.showErrorNotification({ title: result.message || 'Erro ao verificar e-mail.' })
        return
      }

      if (result.exists) {
        this.step = 'password'
        this.isLoading = false
      } else {
        // const responseApiFlamengo = await getUserStatusByEmail(this.email)
        this.isLoading = false

        // console.log(responseApiFlamengo)

        const user = {
          email: this.email
        }
        const queryData = await Util.mapPlanoToConsumerType(user, this.email)
        // const queryData = {
        //   email: this.email,
        //   typeConsumer: responseApiFlamengo?.data?.tipo_pessoa,
        //   idPlano: responseApiFlamengo?.data?.contrato?.idplano
        // }
        this.$router.push({ name: 'register', query: queryData })
      }
    },
    async handleLogin () {
      this.isLoading = true
      const loginSuccess = await doLogin(this.email, this.password, this.rememberPassword)
      this.isLoading = false
      if (loginSuccess) {
        this.$router.push('/')
      } else if (this.password === '%use@stored@pass%') {
        this.password = ''
        this.step = 'password'
      }
    },
    getLogo: function (params) {
      // if (this.getAppDefinitions?.appLogo) {
      // return this.getAppDefinitions?.appLogo
      // } else {
      return require('@/assets/logo/logo.png')
      // }
    }
  },
  mounted () {
    const storedUser = Util.getLocalVar('storedUser')
    if (storedUser?.rememberPassword) {
      this.email = storedUser.email
      if (this.email) {
        this.handleEmailStep()
      }
    }
  }
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  width: 100%;
  overflow-y: auto;
}

.logo {
  width: 160px;
  margin-bottom: 20x;
  filter: drop-shadow(1px 1px 1px black);
}

.login-content {
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.login-form {
  display: flex;
  flex-direction: column;

  .instruction {
    font-size: 14px;
    margin-bottom: 20px;
    text-align: left;
  }

  .step-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;

    .back-button {
      cursor: pointer;
      color: var(--primaryColor);
      margin-bottom: 10px;
      font-size: 14px;
    }
    .user-email-display {
      font-weight: bold;
      line-break: anywhere;
    }
  }

  .form-group {
    margin-bottom: 15px;

    label {
      display: block;
      font-size: 14px;
      margin-bottom: 8px;
      text-align: left;
    }

    input {
      width: 100%;
      height: 44px;
      padding: 10px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius: 5px;
      background-color: var(--primaryColorTransparent, #f9f9f9); // fallback
      transition: border-color 0.3s ease;

      &:focus {
        border-color: var(--primaryColor);
        outline: none;
      }
    }
  }

  .forgot-password {
    font-size: 12px;
    margin-bottom: 20px;
    text-align: right;
    color: var(--primaryColor);
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .divider-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;

    .divider-line {
      flex: 1;
      height: 1px;
      background-color: var(--primaryColor);
      opacity: 0.6;
    }

    .divider-text {
      margin: 0 10px;
      font-size: 14px;
      color: var(--primaryColor);
      white-space: nowrap;
    }
  }

  .button {
    width: 100%;
    padding: 14px 0;
    font-size: 16px;
    text-transform: uppercase;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    transition: background-color 0.3s ease;

    &:not(.singup) {
      background-color: var(--primaryColor);
      color: white;

      &:hover {
        background-color: #180837; // versão mais escura opcional
      }
    }

    &.singup {
      background-color: transparent;
      color: var(--primaryColor);
      border: 1px solid var(--primaryColor);

      &:hover {
        background-color: rgba(33, 9, 70, 0.05);
      }
    }
  }
}
  </style>
